import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import PumpIcon from 'console/images/heating-circuit/pump.svg';
import * as classnames from 'classnames';
import { ResponsiveIcon, } from 'console/shared/components/icon/responsive';
export const PumpIndicator = memo(function PumpIndicator(props) {
    const { active, name, ...rest } = props;
    return (_jsx(ResponsiveIcon, { Icon: PumpIcon, fontSize: "0.65em", className: classnames('pump-indicator', {
            active,
        }), ...rest }));
});
